import React from 'react';
import type ServicedeskReportsHomePageType from '@atlassian/jira-spa-apps-servicedesk-reports-home-page/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { HOME_PAGE_SUFFIX } from '../../common/constants.tsx';

export const LazyServicedeskReportsHomePage = lazyForPaint<typeof ServicedeskReportsHomePageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-reports-home-page", jiraSpaEntry: "async-servicedesk-reports-workload" */ '@atlassian/jira-spa-apps-servicedesk-reports-home-page'
			),
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskReportsHomePage}
		pageId={`spa-apps/servicedesk${HOME_PAGE_SUFFIX}}`}
		shouldShowSpinner
	/>
);
